export const jobsFilterProperties = {
	STATUS: 'status',
	GRADE: 'grade',
	BANDFROM: '$bandFrom',
	BANDTO: '$bandTo',
	AREAS: 'areas',
	SKILLS: 'skills',
	RATE_STATUS: 'rateStatus',
	TIERS: 'tiers',
	FULFILMENT_TYPE: 'fulfillmentType',
	DATE_FROM: 'dateFrom',
	DATE_TO: 'dateTo',
	JOBTITLE: 'title',
	CARE_LOCATION: 'careLocationId',
};

export const jobStatusTypes = {
	VACANT: 'vacant',
	BOOKED: 'booked',
	NO_LOG: 'noLog',
	READY_FOR_APPROVE: 'readyForApprove',
	APPROVED: 'approved',
	COMPLETED: 'completed',
};

export const jobRatesTypes = {
	ALL: 'all',
	PENDING: 'pending',
	NO_UPLIFT: 'noUplift',
	APPROVED: 'approved',
	REJECTED: 'rejected',
};

export const jobFulfilmentTypes = {
	URGENT: 'Urgent',
	MANUAL: 'Manual',
	AUTOFILL: 'Autofill',
};

export const jobsFilterRoutes = {
	BANK_SHIFTS_ROUTE: '/jobs/list',
	JOB_RATES_ROUTE: '/jobs/list/job-rates',
};

export const dateRangeTypes = {
	selectedDay: 'selectedDay',
	thisMonth: 'thisMonth',
	thisWeek: 'thisWeek',
	custom: 'custom',
};

export const dateTypes = [
	{ key: dateRangeTypes.selectedDay, value: 'Day Selected' },
	{ key: dateRangeTypes.thisMonth, value: 'This Month' },
	{ key: dateRangeTypes.thisWeek, value: 'This week' },
	{ key: dateRangeTypes.custom, value: 'Custom' },
];

export const rateStatuses = [
	{ key: 'all', value: 'All' },
	{ key: 'noUplift', value: 'No Uplift' },
	{ key: 'pending', value: 'Pending' },
	{ key: 'intermediate_approved', value: 'Intermediate Approved' },
	{ key: 'intermediate_rejected', value: 'Intermediate Rejected' },
	{ key: 'approved', value: 'Approved' },
	{ key: 'rejected', value: 'Rejected' },
];

export const jobTiers = [
	{ key: 1, value: 'Tier 1' },
	{ key: 2, value: 'Tier 2' },
	{ key: 3, value: 'Tier 3' },
];

export const fulfilmentTypes = [
	{ key: 'Urgent', value: 'Urgent' },
	{ key: 'Manual', value: 'Manual' },
	{ key: 'Autofill', value: 'Autofill' },
];
